import { Component, OnInit, ViewChild } from '@angular/core';
import { loadMessages } from 'devextreme/localization';
import { TranslateService } from '@ngx-translate/core';
import { genericCustomStoreService } from 'src/app/shared/services/genericCustomStore.service';
import { CheckValidation } from 'src/app/shared/services/hr/CheckValidation.service';
import { ObjectsService } from 'src/app/shared/services/hr/objects.service';
import { HandleError, HttpErrorHandler } from 'src/app/shared/services/http-error-handler.service';
import { DxDataGridComponent } from 'devextreme-angular';

@Component({
  selector: 'app-duration-work-system',
  templateUrl: './duration-work-system.component.html',
  styleUrls: ['./duration-work-system.component.scss']
})
export class DurationWorkSystemComponent implements OnInit {
  button = {}
  private handleError: HandleError;
  customDataSource: any;
  FixedPeriod: boolean = false;
  date = new Date()
  addpopup: string = ''
  attendanceFromHour: any;
  LOCALIZATION_LOCAL_STORAGE_KEY = "Language";
  currentLang: any;
  @ViewChild(DxDataGridComponent) grid: DxDataGridComponent;

  constructor(httpErrorHandler: HttpErrorHandler, public gt: genericCustomStoreService
    , private validation: CheckValidation, public Objects: ObjectsService, public translate: TranslateService) {
    gt.seturl("DurationWorkSystem");
    this.handleError = httpErrorHandler.createHandleError('DurationWorkSystem');

    gt.submit();
    this.customDataSource = gt.customDataSource;
    this.button = Objects.button;
    this.validateAsync = this.validateAsync.bind(this);
    this.isFixedPeriod = this.isFixedPeriod.bind(this)
    this.currentLang = localStorage.getItem(
      this.LOCALIZATION_LOCAL_STORAGE_KEY
    );

    loadMessages({
      en: { "Yes": this.translate.instant('personal.yes'), "No": this.translate.instant('personal.no') }
    });
  }
  ngOnInit(): void {

    this.overrideInsertAndUpdate();


  }
  validateAsync(params: any) {
    var id = params.data.id ?? 0;
    return this.validation.asyncCheckNameValue(params.value, id, "DurationWorkSystem");
  }
  formatTimeOnly(date: Date): string {
    if (!(date instanceof Date)) return '';
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    return `${hours}:${minutes}:${seconds}`;
  }

  transformTimesForBackend(row: any): any {
    const transformed = { ...row };

    if (transformed.attendanceFromHour instanceof Date) {
      transformed.attendanceFromHour = this.formatTimeOnly(transformed.attendanceFromHour);
    }

    if (transformed.leaveToHour instanceof Date) {
      transformed.leaveToHour = this.formatTimeOnly(transformed.leaveToHour);
    }

    return transformed;
  }

  updateRow(options: any) {
    options.newData = Object.assign(options.oldData, options.newData);
  }

  isFixedPeriod(newData: any, value: any) {
    newData.isFixedPeriod = value
    this.FixedPeriod = value
  }

  onEditingStart(e: { data: { isFixedPeriod: boolean } }) {
    this.FixedPeriod = e.data.isFixedPeriod
    this.addpopup = this.translate.instant('tableinfo.editbutton')

  }
  onInitNewRow(e: Event) {
    this.FixedPeriod = false
    this.addpopup = this.translate.instant('tableinfo.addbutton')

  }

  validateNumber(e: any) {
    if (!e.data.isFixedPeriod) {
      const from = e.data?.attendanceFromHour;
      const to = e.data?.leaveToHour;

      if (from instanceof Date && to instanceof Date) {
        const fromTime = from.getHours() * 60 + from.getMinutes();
        const toTime = to.getHours() * 60 + to.getMinutes();
        return fromTime < toTime;
      }
    }
    return true;
  }

  onEditorPreparing(e: any) {
    if (e.parentType === "dataRow" && e.dataField === "isFixedPeriod") {
      e.editorName = "dxCheckBox"
      e.editorOptions.value = e.value || false;
      e.editorOptions.onValueChanged = function (args: any) {
        e.setValue(args.value);
      }
    }

    if (e.parentType === "dataRow" && e.dataField === "attendanceFromHour") {
      e.editorOptions.disabled = e.row.data && this.FixedPeriod == true;
    }
    if (e.parentType === "dataRow" && e.dataField === "leaveToHour") {

      e.editorOptions.disabled = e.row.data && this.FixedPeriod == true;
    }
    if (e.parentType === "dataRow" && e.dataField === "numberOfHours") {
      e.editorOptions.disabled = e.row.data && this.FixedPeriod == false;
    }
    if (e.parentType == 'dataRow') {
      e.editorOptions.onInitialized = function (arg: any) {
        arg.component.registerKeyHandler("escape", function (arg: any) {
          e.component.cancelEditData();
        });
      }
    }

  }
  addrowfun(name: string) {
    return this.gt.addrow(name)
  }
  overrideInsertAndUpdate() {
    const originalInsert = this.customDataSource.insert;
    const originalUpdate = this.customDataSource.update;

    this.customDataSource.insert = (values: any) => {
      const transformed = this.transformTimesForBackend(values);
      return originalInsert.call(this.customDataSource, transformed);
    };

    this.customDataSource.update = (key: any, values: any) => {
      // Merge existing row data if needed (optional)
      const rowIndex = this.grid.instance.getRowIndexByKey(key);
      const rowData = this.grid.instance.getKeyByRowIndex(rowIndex);
      const fullData = { ...rowData, ...values };

      const transformed = this.transformTimesForBackend(fullData);
      return originalUpdate.call(this.customDataSource, key, transformed);
    };
  }

}
